export default __webpack_public_path__ + "static/media/Hood of Fiendish Invocation.6f689c9d.jpg";